/**
 * Image Mosaic Module
 *
 * @package EVT Restaurant Builder
 * @since 1.0.0
 */

/**
 * Initialize Image Mosaic pattern with mobile slider
 */
export function initImageMosaic() {
    const mosaicContainers = document.querySelectorAll('.evt-mosaic');

    if (!mosaicContainers.length) {
        return;
    }

    // Function to check if we're on mobile
    function isMobile() {
        return window.innerWidth <= 768;
    }

    // Function to convert grid to Swiper on mobile
    function initMobileSlider(container) {
        const grid = container.querySelector('.evt-mosaic__grid');
        if (!grid || grid.classList.contains('swiper-initialized')) {
            return;
        }

        if (isMobile()) {
            // Get all images from the grid
            const images = grid.querySelectorAll('.evt-mosaic__image img');

            if (!images.length) {
                return;
            }

            // Create Swiper wrapper structure
            const swiperWrapper = document.createElement('div');
            swiperWrapper.className = 'swiper';

            const swiperSlideWrapper = document.createElement('div');
            swiperSlideWrapper.className = 'swiper-wrapper';

            const swiperPagination = document.createElement('div');
            swiperPagination.className = 'swiper-pagination';

            // Convert images to slides
            images.forEach(img => {
                const slide = document.createElement('div');
                slide.className = 'swiper-slide';
                const clonedImg = img.cloneNode(true);
                slide.appendChild(clonedImg);
                swiperSlideWrapper.appendChild(slide);
            });

            swiperWrapper.appendChild(swiperSlideWrapper);
            swiperWrapper.appendChild(swiperPagination);

            // Hide the original grid rows and append swiper
            const rows = grid.querySelectorAll('.evt-mosaic__row');
            rows.forEach(row => row.style.display = 'none');
            grid.appendChild(swiperWrapper);

            // Initialize Swiper if library is available
            if (typeof Swiper !== 'undefined') {
                new Swiper(swiperWrapper, {
                    slidesPerView: 1.2,
                    spaceBetween: 22,
                    loop: true,
                    autoHeight: false,
                });
                grid.classList.add('swiper-initialized');
            } else {
                console.warn('Swiper library not loaded. Image mosaic will display as static grid.');
            }
        }
    }

    // Function to destroy Swiper on desktop
    function destroyMobileSlider(container) {
        const grid = container.querySelector('.evt-mosaic__grid');
        if (!grid || !grid.classList.contains('swiper-initialized')) {
            return;
        }

        if (!isMobile()) {
            const swiperContainer = grid.querySelector('.swiper');
            if (swiperContainer) {
                swiperContainer.remove();
            }

            const rows = grid.querySelectorAll('.evt-mosaic__row');
            rows.forEach(row => row.style.display = '');
            grid.classList.remove('swiper-initialized');
        }
    }

    // Initialize for each mosaic container
    mosaicContainers.forEach(container => {
        initMobileSlider(container);
    });

    // Handle resize with debounce
    let resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            mosaicContainers.forEach(container => {
                destroyMobileSlider(container);
                initMobileSlider(container);
            });
        }, 250);
    });
}